'use client';

import { cssObjectToString } from '../css-object-to-string/css-object-to-string.mjs';

function stylesToString(_ref) {
  var selector = _ref.selector,
      styles = _ref.styles,
      media = _ref.media,
      container = _ref.container;
  var baseStyles = styles ? cssObjectToString(styles) : "";
  var mediaQueryStyles = !Array.isArray(media) ? [] : media.map(function (item) {
    return "@media".concat(item.query, "{").concat(selector, "{").concat(cssObjectToString(item.styles), "}}");
  });
  var containerStyles = !Array.isArray(container) ? [] : container.map(function (item) {
    return "@container ".concat(item.query, "{").concat(selector, "{").concat(cssObjectToString(item.styles), "}}");
  });
  return "".concat(baseStyles ? "".concat(selector, "{").concat(baseStyles, "}") : "").concat(mediaQueryStyles.join("")).concat(containerStyles.join("")).trim();
}

export { stylesToString };